const translations = {
wineSelection: {
  title: {
    fr: "L'ACADÉMIE DU VIN DE BORDEAUX",
    en: "THE ACADÉMIE DU VIN DE BORDEAUX",
    zh: "波尔多葡萄酒学院"
  },
  subtitle: {
    fr: "Garantir et diffuser l’esprit, l’histoire et la culture du vin de Bordeaux",
    en: "Preserving and sharing the spirit, history and culture of Bordeaux’s wines",
    zh: "传承和弘扬波尔多葡萄酒的精神、历史与文化"
  },
  paragraph: {
    fr: "Depuis 1954, l’Académie du Vin de Bordeaux publie son Code des Millésimes permettant aux amateurs d’être guidés au moment de l’achat ou de l’ouverture d’un vin de Bordeaux. Établi par un collège d’experts, ce document renseigne par millésime et par couleur, le niveau de réussite, le stade d’évolution et la puissance ou la richesse d’un vin :",
    en: "The Académie du Vin de Bordeaux has been publishing its Code des Millésimes (Vintage Code) since 1954 to assist wine enthusiasts when purchasing and opening Bordeaux’s wines. Established by a panel of experts, this guide provides information, for each vintage and each colour of wine, on its Quality, Evolution and Power or Richness:",
    zh: "自1954年以来, 波尔多葡萄酒学院发布了《年份编码》，为葡萄酒爱好者在购买或开启葡萄酒时提供指导。该编码由专家委员会制定，按年份和颜色提供葡萄酒的成功程度、成熟阶段和浓郁度信息："
  },
  quote: {
    fr: '"Les vins blancs secs, très agréables dans leur jeunesse, développent en vieillissant toutes les nuances de leurs arômes. Avec le temps les vins liquoreux révèlent la complexité de leurs saveurs. Si les vins rouges séduisent souvent dès les premières années, l’amateur aime suivre leur évolution jusqu’au plein épanouissement de leur bouquet".',
    en: '"Dry white wines, while very pleasant when young, evolve to express the subtleties of their character as they age. Over time, sweet wines reveal the complexity of their flavours. Red wines are often seductive in their early years; wine enthusiasts enjoy following their evolution as they gradually reveal their full potential."',
    zh: "“年轻的干白葡萄酒清新怡人，随着陈年展现出香气的丰富层次。甜白葡萄酒则随着时间展现出风味的复杂性。红葡萄酒虽然常在年轻时就颇具吸引力，但爱酒之人更愿意追随其演变至完全绽放。”"
  },
  invite: {
    fr: "Pour accéder aux Millésimes, choisissez la couleur du vin :",
    en: "To access the Vintage Code, choose the wine color:",
    zh: "请选择葡萄酒的颜色以进入年份编码："
  },
  invite2: {
    fr: "Les Millésimes qui ne figurent pas dans ce document ont pu être retirés soit parce que les vins sont devenus trop rares sur le marché, soit parce que leur déclin est trop marqué.",
    en: "Vintages not listed may have been withdrawn either because the wines became too rare on the market, or because their decline was too marked.",
    zh: "未列出的年份可能是因为在市场上过于罕见，或因为其衰退过于明显而被撤销。"
  },
  selectedWineType: {
  fr: {
    rouge: "Code des Millésimes des vins rouges",
    blanc_sec: "Code des Millésimes des vins blancs secs",
    blanc_liquoreux: "Code des Millésimes des vins blancs liquoreux"
  },
  en: {
    rouge: "Vintage Code for red wines",
    blanc_sec: "Vintage Code for dry white wines",
    blanc_liquoreux: "Vintage Code for sweet white wines"
  },
  zh: {
    rouge: "红葡萄酒年份编码",
    blanc_sec: "干白葡萄酒年份编码",
    blanc_liquoreux: "甜白葡萄酒年份编码"
  }
},
  legendExplanation: 
  {
  fr: {
      title: "Le Code des Millésimes repose donc sur 3 critères fondamentaux :",
     legend: [
      { label: "Réussite", text: "du millésime concerné," },
      { label: "Évolution", text: "du vin dans le temps pour le millésime en question," },
      { label: "Puissance - Richesse", text: "du vin dans le millésime concerné." }
      ],
     explanationIntro: "Pour chaque Millésime, la combinaison de ces 3 critères permet :",
      explanationBullets: [
      "d’anticiper la qualité d’un vin avant son ouverture,",
      "de prévoir la date d'ouverture idéale pour une bouteille,",
      "de suivre l’évolution des vins de sa cave."
     ]
    },
  en: {
    title: "The Vintage Code is therefore based on 3 fundamental criteria:",
    legend: [
      { label: "Quality", text: "of the vintage in question," },
      { label: "Evolution", text: "of the wine over time for that vintage," },
      { label: "Power - Richness", text: "of the wine in that vintage." }
    ],
    explanationIntro: "For each vintage, the combination of these 3 criteria allows:",
    explanationBullets: [
      "to anticipate the quality of a wine before opening,",
      "to plan the ideal opening date for a bottle,",
      "to follow the evolution of wines in one's cellar."
    ]
  },
  zh: {
    title: "年份编码基于三个基本标准：",
    legend: [
      { label: "成功", text: "指该年份的表现，" },
      { label: "演变", text: "指该年份葡萄酒的成熟进程，" },
      { label: "力量 - 富裕", text: "指该年份葡萄酒的力量或复杂度。" }
    ],
    explanationIntro: "对于每个年份，这三个标准的组合可帮助：",
    explanationBullets: [
      "在开启前判断葡萄酒的品质，",
      "规划理想的开瓶时间，",
      "追踪酒窖中葡萄酒的演变过程。"
    ]
  },
},
},
  credits: {
  title: {
    fr: "Crédits",
    en: "Credits",
    zh: "鸣谢"
  },
  text: {
    fr: "Le Code des Millésimes est une publication de l'Académie du Vin de Bordeaux",
    en: "The Vintage Code is a publication of the Académie du Vin de Bordeaux",
    zh: "《年份编码》由波尔多葡萄酒学院出版"
  },
  note: {
  "fr": "La version digitale du Code des Millésimes est issue d’un document publié et imprimé régulièrement par l’Académie du Vin de Bordeaux depuis 1954.",
  "en": "The Code des Millésimes is regularly published and printed out since 1954.",
  "zh": "年份编码的数字版本源自波尔多葡萄酒学院自1954年起定期出版和印刷的纸质文件。"
},
address: {
  fr: [
    { type: "text", value: "1 cours du 30 Juillet - 33000 Bordeaux - France" },
    { type: "text", value: "+33(0)5 56 00 21 95" },
    { type: "link", label: "academieduvinsdebordeaux.fr", url: "https://academieduvinsdebordeaux.fr" }
  ],
  en: [
    { type: "text", value: "1 cours du 30 Juillet - 33000 Bordeaux - France" },
    { type: "text", value: "+33(0)5 56 00 21 95" },
    { type: "link", label: "academieduvinsdebordeaux.fr", url: "https://academieduvinsdebordeaux.fr" }
  ],
  zh: [
    { type: "text", value: "法国 波尔多 33000" },
    { type: "text", value: "七月三十日大道1号" },
    { type: "text", value: "+33(0)5 56 00 21 95" },
    { type: "link", label: "academieduvinsdebordeaux.fr", url: "https://academieduvinsdebordeaux.fr" }
  ]
},

contact: {
  fr: { label: "email : academie@vins-bordeaux.fr", url: "mailto:academie@vins-bordeaux.fr" },
  en: { label: "email: academie@vins-bordeaux.fr", url: "mailto:academie@vins-bordeaux.fr" },
  zh: { label: "电子邮件: academie@vins-bordeaux.fr", url: "mailto:academie@vins-bordeaux.fr" }
},
social: {
  fr: [
    { label: "Facebook : @academieduvindebordeaux33", url: "https://facebook.com/academieduvindebordeaux33" },
    { label: "Instagram : @academievindebordeaux", url: "https://instagram.com/academievindebordeaux" }
  ],
  en: [
    { label: "Facebook: @academieduvindebordeaux33", url: "https://facebook.com/academieduvindebordeaux33" },
    { label: "Instagram: @academievindebordeaux", url: "https://instagram.com/academievindebordeaux" }
  ],
  zh: [
    { label: "脸书：@academieduvindebordeaux33", url: "https://facebook.com/academieduvindebordeaux33" },
    { label: "Instagram:@academievindebordeaux", url: "https://instagram.com/academievindebordeaux" }
  ]
},
  rights: {
    fr: "© Tous droits de reproduction réservés",
    en: "© All reproduction rights reserved",
    zh: "© 版权所有"
  }
},

degustation: {
  fr: {
    title: "Pour votre dégustation",
    tempTitle: "TEMPÉRATURE",
    tempText: "il est conseillé de servir les vins blancs entre 8 et 12 degrés, les vins rouges entre 16 et 18 degrés.",
    glassTitle: "VERRES",
    glassText: "la forme des verres influe beaucoup sur la perception des arômes du vin. On utilise traditionnellement à Bordeaux, un verre de forme “tulipe” rempli au tiers.",
    carafeTitle: "MISE EN CARAFE",
    carafeText: "un vin rouge jeune peut être transvasé dans une carafe pour en libérer les arômes. La durée de la mise en carafe dépendra de l’âge du vin.",
    decantTitle: "DÉCANTATION",
    decantText: "un dépôt naturel peut se former dans la bouteille, signe du bon vieillissement de votre vin : verser délicatement votre vin dans une carafe permet d'éliminer ce dépôt."
  },
  en: {
    title: "Tasting tips",
    tempTitle: "TEMPERATURE",
    tempText: "white wines should be served between 8 and 12 degree Celsius, red wines between 16 and 18 degree Celsius.",
    glassTitle: "GLASSES",
    glassText: "the shape of the glass has a significant effect on the perception of the wine's aromas. Traditionally in Bordeaux, a tulip-shaped glass filled to one-third is used.",
    carafeTitle: "AERATION",
    carafeText: "a young red wine can be poured into a carafe to release its aromas. The wine's age will determine how long beforehand it should be decanted.",
    decantTitle: "DECANTING",
    decantText: "a natural deposit may form in the bottle, a sign that your wine is ageing well: decanting carefully will remove any sediment."
  },
  zh: {
    title: "品酒建议",
    tempTitle: "温度",
    tempText: "建议白葡萄酒在8至12摄氏度之间饮用，红葡萄酒在16至18摄氏度之间饮用。",
    glassTitle: "酒杯",
    glassText: "酒杯的形状会极大影响葡萄酒香气的感知。在波尔多，传统使用三分之一满的“郁金香”形酒杯。",
    carafeTitle: "醒酒",
    carafeText: "红葡萄酒可以倒入醒酒器以释放香气。醒酒时间取决于酒的年份。",
    decantTitle: "沉淀",
    decantText: "瓶中可能会形成天然沉淀，这是葡萄酒良好陈年的标志：醒酒有助于去除这些沉淀。"
  }
},

 chateaux: {
  mainTitle: {
    fr: "MEMBRES ASSOCIÉS DE L'ACADÉMIE DU VIN DE BORDEAUX",
    en: "ASSOCIATE MEMBERS OF THE ACADEMIE DU VIN DE BORDEAUX",
    zh: "波尔多葡萄酒学院的成员酒庄",
  },
  subTitle: {
    fr: "CHÂTEAUX",
    en: "CHÂTEAUX",
    zh: "酒庄",
  },
  negociants: {
    fr: "NÉGOCIANTS",
    en: "WINE MERCHANTS",
    zh: "酒商",
  },
  brokers: {
    fr: "COURTIERS",
    en: "WINE BROKERS",
    zh: "葡萄酒经纪人",
  },
  institution: {
    fr: "INSTITUTION",
    en: "INSTITUTION",
    zh: "葡萄酒组织",
  },
},
 
presentation: {
  fr: {
    title: "Notice du Code des Millésimes",
    subtitle: "Légende utilisée dans le Code des Millésimes :",
    intro: "Le Code des Millésimes repose donc sur 3 critères fondamentaux :",
    legend: [
      { label: "Réussite", text: "du millésime concerné," },
      { label: "Évolution", text: "du vin dans le temps pour le millésime en question," },
      { label: "Puissance - Richesse", text: "du vin dans le millésime concerné." }
    ],
    uses: {
      intro: "Pour chaque Millésime, la combinaison de ces 3 critères permet :",
      bullets: [
        "d’anticiper la qualité d’un vin avant son ouverture,",
        "de prévoir la date d'ouverture idéale pour une bouteille,",
        "de suivre l’évolution des vins de sa cave."
      ]
    },

    success: {
      title: "Réussite",
      levels: [
        "Très belle réussite",
        "Belle réussite générale",
        "Réussite inégale, quelques très bonnes bouteilles"
      ]
    },
    evolution: {
      title: "Évolution",
      levels: [
        "Ils ont le fruit des vins jeunes et tout l’avenir devant eux",
        "Ils atteignent une certaine maturité et continueront à se développer",
        "Ils sont en plein épanouissement et peuvent poursuivre leur évolution dans de bonnes caves",
        "Ils ont atteint leur apogée"
      ]
    },
    power: {
      title: "Puissance - Richesse",
      blancsSecs: {
        title: "BLANCS SECS",
        levels: [
          "Fruités, délicats, nerveux",
          "Bien équilibrés, fins, élégants",
          "Matures, aromatiques, très fins"
        ]
      },
      blancsLiquoreux: {
        title: "BLANCS LIQUOREUX",
        levels: [
          "Fins, fruités, élégants",
          "Ronds, équilibrés, avec beaucoup de “rôti”",
          "Riches, séveux, complexes"
        ]
      },
      rouges: {
        title: "ROUGES",
        levels: [
          "Fins, fruités, élégants",
          "Bien équilibrés, riches, harmonieux",
          "Corsés, fortement charpentés"
        ]
      }
    }
  },
  en: {
    title: "Vintage Code notice",
    subtitle: "Legend used in the Vintage Code :",
    intro: "The Vintage Code is based on an expert reading of Bordeaux wines, organized around 3 key criteria:",
    legend: [
      { label: "Quality", text: "of the vintage" },
      { label: "Evolution", text: "of the wine" },
      { label: "Power - Richness", text: "of the wine" }
    ],
    uses: {
      intro: "For each vintage, the combination of these 3 criteria allows:",
      bullets: [
        "to anticipate the quality of a wine before opening",
        "to compare the characteristics of a red, dry white or sweet wine",
        "to track the evolution of vintage styles over time"
      ]
    },
    success: {
      title: "Quality",
      levels: [
        "Excellent",
        "Generally good",
        "Uneven, some very good wines"
      ]
    },
    evolution: {
      title: "Evolution",
      levels: [
        "Fruity young wines with a long future ahead of them",
        "Have acquired some maturity and will continue to develop",
        "Excellent maturity, may continue to evolve in good cellar conditions",
        "At their peak"
      ]
    },
    power: {
      title: "Power - Richness",
      blancsSecs: {
        title: "DRY WHITES",
        levels: [
          "Fruity, delicate, lively",
          "Well balanced, refined, elegant",
          "Mature, full-flavoured, very refined"
        ]
      },
      blancsLiquoreux: {
        title: "SWEET WHITES",
        levels: [
          "Refined, fruity, elegant",
          "Round, balanced, concentraded",
          "Rich, opulent, complex"
        ]
      },
      rouges: {
        title: "REDS",
        levels: [
          "Refined, fruity, elegant",
          "Well-balanced, rich, harmonious",
          "Full-bodied, well structured"
        ]
      }
    }
  },
  zh: {
    title: "复古代码传单",
    subtitle: "千禧年法》中使用的图例：",
    intro: "年份编码基于对波尔多葡萄酒的专家解读，围绕三个关键标准组织：",
    legend: [
      { label: "成功", text: "年份的质量" },
      { label: "演变", text: "葡萄酒的成熟阶段" },
      { label: "力量 - 丰饶", text: "葡萄酒的力量或丰富度" }
    ],
    uses: {
      intro: "每个年份中，这三个标准的组合可用于：",
      bullets: [
        "在开启之前评估葡萄酒的质量",
        "比较红葡萄酒、干白葡萄酒或甜白葡萄酒的特征",
        "追踪年份风格随时间的演变"
      ]
    },
    success: {
      title: "成功",
      levels: [
        "非常成功",
        "整体表现良好",
        "表现不一，有些酒表现优秀"
      ]
    },
    evolution: {
      title: "演变",
      levels: [
        "具有年轻葡萄酒的果味，未来可期",
        "达到一定成熟度，将继续发展",
        "正处于巅峰，可在良好酒窖中继续陈年",
        "已达到成熟巅峰"
      ]
    },
    power: {
      title: "力量 - 丰饶",
      blancsSecs: {
        title: "干白葡萄酒",
        levels: [
          "果香、细腻、有活力",
          "平衡良好、精致、优雅",
          "成熟、芳香、极其精致"
        ]
      },
      blancsLiquoreux: {
        title: "甜白葡萄酒",
        levels: [
          "精致、果香、优雅",
          "圆润、平衡，带有明显“烘烤香”",
          "浓郁、顺滑、复杂"
        ]
      },
      rouges: {
        title: "红葡萄酒",
        levels: [
          "精致、果香、优雅",
          "平衡良好、丰富、和谐",
          "酒体浓厚、结构坚实"
        ]
      }
    }
  }
}
};

export default translations;
